// Shared by EPG, playback buttons and players so package messages stay consistent.
function asIds(value) {
  if (typeof value === 'string') {
    try { value = JSON.parse(value.replace(/'/g, '"')); }
    catch (error) { value = [value]; }
  }
  return (Array.isArray(value) ? value : value == null ? [] : [value])
    .filter(id => id != null).map(id => String(id).trim());
}

function hasFootballPackage(channel, appConfig) {
  const config = appConfig || {};
  const footballIds = asIds(config.footballAvailabilityIds || config.footballPackages);
  // Rails, search, EPG and DRM responses can carry availability in different fields.
  const availabilityIds = [
    ...asIds(channel.availabilityset),
    ...asIds(channel.drmTokenResp?.availabilitydetails?.availabilityid),
    ...(Array.isArray(channel.contentdetails) ? channel.contentdetails : [])
      .reduce((ids, detail) => ids.concat(asIds(detail.availabilityset)), [])
  ];
  return availabilityIds.some(id => footballIds.includes(id));
}

export const channelAccessMethods = {
  isFootballChannel(content) {
    return Boolean(content && (content.category === 'TVCHANEL' || content.objecttype === 'CHANEL') &&
      hasFootballPackage(content, this.appConfig));
  },
  getUnsubscribedMessage(channelData) {
    const channel = channelData && typeof channelData === 'object' ? channelData : {};
    const name = String(typeof channelData === 'string' ? channelData :
      channel['display-name'] || channel.title || channel.name || channel.displayName || '').trim();
    const isFootball = channel.category || channel.objecttype
      ? this.isFootballChannel(channel) : hasFootballPackage(channel, this.appConfig);
    return this.$t(isFootball ? 'liveContentAccessErrorFootball' : 'liveContentAccessErrorExtended', {
      name: isFootball ? name : name ? ` ${name}` : ''
    });
  },
  getPlaybackErrorMessage(error, content) {
    if (String(error?.errorcode) === '8882' &&
        this.isFootballChannel({ ...content, drmTokenResp: error })) {
      return this.getUnsubscribedMessage({ ...content, drmTokenResp: error });
    }
    return this.$t(error?.reason);
  }
};
